module.exports = __webpack_public_path__ + "img/close_icon.aece280f.png";